import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  .subHeader {
    display: flex;
    gap: 1rem;
    align-items: center;

    svg {
      height: 2rem;
      fill: #b10000;
    }

    h1 {
      color: #b10000;
      font-size: 1.3rem;
      margin: 0;
      font-weight: 300;
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const ContentModal = styled.div`
  h2 {
    margin: 1rem 0 0.5rem 0;
    font-size: 14px;
    color: #8d8d8d;
    font-weight: 300;
  }

  p {
    font-weight: 300;
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 18px;

    &:first-child {
      margin-bottom: 0.5rem;
    }
  }

  .buttonModal {
    display: flex;
    justify-content: space-between;
    margin: 2rem 1rem 0 0;
  }

  @media (max-width: 370px) {
    .buttonModal {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin: 2rem 0 0 0;

      button {
        width: 100% !important;
      }
    }
  }
`;
